













































import Vue from "vue";
import Component from "vue-class-component";

import { authenticationService } from "../services";
import { AuthenticationResponse } from "../models";

@Component
export default class Login extends Vue {
    email = "";
    password = "";

    working = false;
    status: null | AuthenticationResponse = null;

    async login() {
        this.working = true;
        this.status = null;

        const status = await authenticationService.authenticate({
            email: this.email,
            password: this.password
        });

        if (status && status.result === "Success") {
            const authStatus = await authenticationService.getAuthenticationStatus();
            this.$emit("signon", authStatus);
            return;
        }

        this.status = status;
        this.working = false;
    }
}
